const isMaterialInCart = (id: number, cart: Cart) => {
    let inCart = false;

    cart.cartItems?.forEach((cartItem) => {
        if (id === cartItem.material.id) {
            inCart = true;
        }
    });

    return inCart;
};

export default isMaterialInCart;
